import { render, staticRenderFns } from "./ModuleViewer.vue?vue&type=template&id=dc816a8c&scoped=true"
import script from "./ModuleViewer.vue?vue&type=script&lang=js"
export * from "./ModuleViewer.vue?vue&type=script&lang=js"
import style0 from "./ModuleViewer.vue?vue&type=style&index=0&id=dc816a8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc816a8c",
  null
  
)

export default component.exports